module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The young man came striding across the threshold of Louis’s office with all the vigor and self-possession his recommendations had promised, and though something in Louis’s soul paused there momentarily, he dismissed that pause as nothing but a shadow. Tracy Parker’s handshake was firm, his smile clear and winning. And scrupulous punctuality, in Louis’s book, always boded well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please.” He gestured, and Tracy seated himself with the loose-limbed ease of someone who makes himself instantly at home. In deference to the mid-August swelter, he wore no jacket. He’d rolled up the sleeves of his white dress shirt and loosened his tie. His hair, Louis noticed, was in some need of a trim.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not to worry,” Tracy apologized as if having intuited his interviewer’s thoughts. He ran long fingers through lazy, straw-colored locks. “It’s as shaggy as you’ll ever see me. I just didn’t have time to get it cut.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Certainly it was a promising start. Louis dabbed at his brow with a handkerchief and said, “Thanks so much for getting yourself up here on a moment’s notice. I hope you won’t hold the weather against us. The humidity can really be quite ferocious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tracy smiled indulgently. “It’s just as bad down in the city,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think you’ll find the humidity is even worse up here,” Louis told him with some certainty. Then, glancing needlessly over Tracy’s résumé: “I see you’ve been doing carpentry work the last few months.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tracy held out a bare forearm. “How’s this for a tan? It’s probably the best shape I’ll ever be in. At least my body. Though I’m afraid my brain’s turned to mush. I get home at night and all I do is watch TV. I can hardly wait to get back to the life of the mind. Slumber of the mind is what I call the last six months or so. I’m incredibly excited. Books and education and learning are what my real life is all about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have to say,” Louis told him, “that we were really very interested in you back in April. But unfortunately we only had the one position. Though now, as it turns out, we still have that position.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tracy nodded amicably. “You’ve been left in the lurch,” he said. Comfortably—or perhaps it was nervousness—he rested his right ankle on his left knee, and proceeded to massage the knob of his anklebone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis was a little disconcerted to see that Tracy wasn’t wearing any socks. “Left in the lurch. You could say that,” he admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What an odd phrase,” Tracy said reflectively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis didn’t follow. He kept watching, with some skepticism, the gap between khaki cuff and black loafer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I mean, ‘Left in the lurch.’ What do you think that means, exactly? Left in the lurch.” He mouthed the phrase with relish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve got me,” Louis confessed. The curiosity of the young intrigued him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you ever think what a peculiar language we speak?” Tracy went on. Whatever the cause, he seemed admirably able to generate his own enthusiasms out of thin air. “When I was in college, I studied in Germany for a year. I hardly spoke a word of English the whole time, and what it made me realize was what an amazing language English really is. This crazy, jumbled-up language, not like German, that’s so consistent, no exception to the rules. English seemed so alive—like, I don’t know, some kind of slithering snake. I don’t think the German department ever forgave me, but Germany was definitely an important learning experience for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perhaps, Louis thought with a sigh, the young man would turn out to be something of a bore when one got to know him. This penchant his generation had for saying everything at once. Still, to call English a snake was somehow odd and interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have a long-standing interest in Germany myself,” he felt he should mention, if for no other reason than to spare Tracy the need to fill him in too fully on what he called his learning experience.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Have you been there?” Tracy asked animatedly. “I mean, I’m sure you’ve been there. But a lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It made Louis smile. “Oh, fairly frequently,” he told Tracy. “My wife and I. We’ve traveled all over. Munich, Dresden, Berlin, Stuttgart. We enjoy the cultural offerings, especially the opera. There are some splendid provincial operas, you know. We were in Freiburg—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Freiburg,” said Tracy. “That’s exactly where I was—at the university. Freiburg im Breisgau.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Louis’s turned to be dogged. “There was a production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rosenkavalier")]), _vm._v(" we saw four times,” he went on. “So fiercely intelligent. And then we were in Berlin later and saw another production, much better singing, the orchestra was magnificent, but the production was a complete mess. No "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("idea")]), _vm._v(" behind it. That’s what you can get in those smaller theaters. Exciting young directors who have ideas. Who aren’t running on automatic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped. He’d been on the verge of saying, “Running on automatic is the problem with most people’s lives.” But he was wary of seeming to preach. It proved an increasing hazard as the years went by, and there was nothing like the subject of music to draw him out. You should have been a musician, Claire was always telling him—but he had no aptitude whatsoever for music, except as a listener.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Opera’s a bit out of my league,” Tracy admitted with a smile. “I think it’s definitely an acquired taste.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well,” Louis teased, “isn’t that what education’s all about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I’m always willing to be educated,” Tracy affirmed. He smiled broadly, even remarkably, Louis thought; as if a smile could be generous enough to enlarge the recipient as well. He’d seen enough. The spark was there, the earnestness, the enthusiasm. It shone through whatever inexperience might cloud the young man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Besides, with the semester starting in less than three weeks the position needed to be staffed immediately. He’d been wrong about one candidate already, but proceeding with caution wasn’t something he could afford at the moment. That Tracy would take the job seemed a foregone conclusion. Still, he felt he should talk him through one or two things. Youthful enthusiasm could be blind to the broader realities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You haven’t taught much before,” he noted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I taught a year in Japan…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But not American students,” Louis cautioned him. “Especially not our particular brand here. The Forge School fills a certain niche.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was conscious of choosing his words carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our students are not exactly, for the most part, what you would call model students. They’re quite talented, many of them, but for one reason or another they haven’t performed well in their previous schools. Still, they’re boys who should go to college. They come from affluent families, they have good prospects out in the world. But they need an extra bit of prodding. Our mission is to make sure they don’t damage their futures too much at this stage in their lives. Our job, to be blunt about it, is to get them into college. If I may say so, most of our students suffer from a kind of inattentiveness to their best interests. That’s the main challenge: to get these boys to understand their best interests, at least in terms of education. As simple as that. It’s not just about getting them into college. It’s about teaching the value of education. We’re a progressive institution in the best sense of the word. We try to help each of our students find his place and fulfill his potential there. If that interests you, then I’d like to offer you the chance to work with us for the coming year.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d been long-winded—he knew that—but Tracy’s attention hadn’t seemed to flag. The young man furrowed his brow only for a single, inscrutable moment. Then, looking Louis in the eye, his gaze bright and direct: “I think this is something I’d be good at,” he said. “I have to tell you, to be honest—I could make twice as much money carpentering, but this is where my life is. I’m sure of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("So it was done. He could stop fulminating inwardly against the young woman who had so impressed him back in the spring but who had, at the last minute, excused herself with no more than a brief note of apology to say that she had, as she blithely put it, been made an offer she could not refuse by a girls’ school in Lausanne, Switzerland.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d considered firing off a frank note of warning to that Swiss school, but resisted the temptation. At his age, he didn’t need to go ruining crass young lives. Experience had shown that they could manage that quite nicely on their own. And in any event, this Tracy Parker would work out just fine. William and Mary English major, class of 1991, B-plus average, a year’s teaching experience at a technical school for young women in Nagoya. How effortlessly he must have won their hearts with his American good looks and easygoing style. And the Forge School, he suspected, would prove no different. The students would adore him, if for nothing more than that youthful charisma for which there was, one regretfully had to admit, simply no substitute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis himself had possessed such a quality once, had held on to it, in fact, for many years. Teaching had been his life, though his abrupt and traumatic elevation to the post of headmaster had effectively curtailed his classroom activities. It was perhaps just as well. With the years, the task of winning over his students had become harder and harder. He could see the suspiciousness in their eyes, their all-too-understandable reluctance to open themselves to this old man. What on earth had he to tell them anymore about their troubled young worlds?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thus found himself, on this August afternoon of his sixty-fourth year, fiercely envying Tracy Parker the intangible currency of youth he carried so unawares. Twenty-five years old. He had been twenty-five himself when he first started teaching at the Forge School—though he had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(", he reminded himself sternly, in those days felt himself possessed of any kind of currency, intangible or otherwise. Twenty-five was a terrible age, after all; like any other, fraught with all sorts of anxiety and disquiet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moved distractedly about his office, sifting through stacks of paper left over from last semester: obsolete memoranda, reports, notices of one kind or another. Some stacks he shifted from one cluttered surface to another. Would he miss any of them? In a sudden bout of resolve, he took up a batch of pages and, without so much as glancing through them, placed them in the wastebasket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What a mood he felt himself in! August was a month he survived only by creeping from one air-conditioned refuge to the next. His office, unfortunately, was not one of those refuges: Seldom used in the summer months, it had never been modernized. The large windows lay open to the leafy, listless quad. No breeze stirred through. Out on the sun-dappled lawn nothing moved except for two crows that marched arrogantly up and down. Years ago there hadn’t been so many crows, had there? Now scarcely a dawn came when their hideous cries didn’t wrest him from his hard-won sleep. Songbirds, he’d read, were disappearing from North America. The noble raptors, also, were all but wiped out. Crows, jays, grackles—only the scavengers seemed inclined to proliferate. The future promised a tough, ugly world all around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He threw another stack of papers in the trash and, if only to put off the actual exertion a quarter hour more, contemplated the walk home. On fine dry days he loved a brisk walk. Autumns were glorious that way, but in this tropical simmer his body betrayed him. He turned porous; incontinent sweat oozed from him. Whose fine idea had it been, on the Olympian heights or deep in the bowel-dark underworld, to condemn us to the messy, intractable burden of bodies, the sheer tedium of our confinement in the flesh?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wanted nothing so much as to find himself lying on the sofa in his cool, darkened den—wafted there instantly, effortlessly—and listening to music on the stereo, Brahms or Bruckner, body on hold, mind adrift and yet hyperalert, his attention both compelled and freed by the rigorous structures of sound surrounding him. There was this indolence about him; had he been born in the previous century, he might well have found his way to the opium dens, languishing there as his thoughts roamed extraordinary landscapes. It would have been a danger, certainly. The temptation to dream his life away had always lurked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A knock on the door startled him. Reid Fallone’s broad round face peered in slyly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took some effort for Louis to rouse himself from his torpor. “Welcome back,” he said. “You survived.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His colleague glided into the office and conspiratorially shut the door behind him. It was a habit Louis hated: as if anybody would be eavesdropping on an empty campus.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Alas.” Reid sighed. “Survived only to return to this benighted exile. Did you know we’re to have dinner tonight? Libby spoke to Claire. She said you were over here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A headmaster’s work is never done,” Louis told him with a certain degree of satisfaction. “I managed to fill that position we had open back in the spring.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reid looked confused. “I thought we’d already filled it. That terrific young lady from Yale. The one who wrote her thesis on Anthony Trollope.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It turns out she’s not coming. It’s a long story. But dinner’s fine. I’m looking forward to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But that’s terrible,” Reid went on disappointedly. “She was spectacular. Exactly right for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This young man will be just fine. He certainly seems eager enough.” Even as he said it, though, he detected a strain of defensiveness creeping into his voice. Perhaps he had been too hasty. Perhaps he should have consulted Reid before making an offer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Another eager young man,” Reid said. “Just what we need around here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, it’s done,” Louis told him irritably. “For better or worse. But now tell me about Athens. I’m sure you had a marvelous time, as usual. Thanks, by the way, for your cryptic postcards.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reid sighed grandly. “One never knows what to say. Anyway, I’ll regale everybody with the official tales at dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused, and suddenly, out of nowhere, Louis was on the alert. He knew his colleague too well. (What if Tracy Parker wasn’t, in fact, a prudent choice for the job? One gave oneself away at every turn.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I trust your research went well,” Louis prodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, the research,” Reid said distractedly. Already it was too late. Louis braced himself for whatever would come. “It was fine when I could work. But my allergies turned out to be just awful. The smog and the traffic and everything. And oh my God, the heat. I could go on. I didn’t get done half what I had intended. But of course there’s always next summer. And I did manage to track down one or two rather obscure items. That in itself, I suppose…” He stopped midsentence, both of them perfectly familiar with this line of talk. Reid’s research, as he called it, had been going on for more years than Louis cared to count. It was a wonder there were any Byzantine churches left to investigate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though safely behind closed doors, Reid glanced momentarily over his shoulder, a reflex that might, in other circumstances, have been comic. Reaching into the pocket of his rumpled jacket, he withdrew a photograph and, without a word, laid it on Louis’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A blond woman in her midforties stared up at him. She had the leathery look of someone who’d squandered years in the sun. Nevertheless, she retained clear traces of her former beauty. A man’s white dress shirt had been unbuttoned to reveal the black bathing suit she wore underneath. It was night; the setting appeared to be an outdoor café. In the flash of the camera, her eyes glowed. She looked slightly drunk—or startled, caught at something. She seemed put out by the presence of the camera, betrayed by it. He assumed Reid stood behind the viewfinder. Her mouth, its smile fading, seemed about to lash out in complaint. Louis felt a surge of squeamishness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced up at Reid, then back at the photo. He wouldn’t touch it. To touch it would be to involve himself in it. And yet he was already involved. This was hardly the first time Reid had burdened him with such a confession in the nearly forty years they’d been together at the Forge School. There had been that awful hour in the midseventies when he’d confessed, his voice brimming with guilt and exhilaration, the summer’s escapade with a young woman in Ravenna. He’d sworn Louis to strictest secrecy: No one could know; the information would crush poor Libby. Why? Louis asked at the time. Why have you done this? Reid only touched his heart with his fingertips, a delicate gesture he’d learned, perhaps, from ancient frescoes or mosaics, at once so eloquent and absurd that it effectively silenced whatever other questions Louis might have presumed to muster over the years. Because it all happened with depressing regularity: those solitary “research” trips abroad, those end-of-the-summer confessions. Louis felt it his duty to register profound disapproval, but despite the possibility that their friendship had, over the years, perhaps outlived its natural span, he had nonetheless faithfully played his part in the marital deception Reid had pledged him to assist in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sighing deeply, with an air of satisfaction—or was it melancholy?—Reid placed his hands over the paunch he’d negligently allowed himself to acquire down through the years. “She heads the American excavation at Pella,” he said. “Louis, I really fell for her. I think she might be the love of my life.” And he sighed again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t have to tell me any of this,” Louis reminded him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reid looked at him imploringly. “If I don’t tell somebody,” he said, “I’ll begin to think it never happened. And it did happen. I was sitting in a café in Kolonaki. She was at the next table. Kept sending glances my way, then long frank stares. I was talking to a fellow Byzantinist about the mosaics at Daphne, and then when I was finished, she came over and said, ‘Your English is so good, I thought you must be the leader of the Hungarian team.’ Not a trace of a smile. How could I not fall for that? We went right down to her hotel in the Plaka. The afternoon sun was coming in through the windows. She’s such a terribly avid person, Louis, so hungry for life. I had the sense of just being—how shall I say?"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("—enveloped")]), _vm._v(" by her. I was practically floating in the light.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis took out his handkerchief and ran it across his forehead. “At least spare me the more gruesome details,” he said dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh,” Reid told him, “there are no gruesome details. She teaches at the University of Texas—married, alas, with three children. Entanglements, entanglements. They joined her in Athens there at the end, which was awkward. She didn’t want me to meet them, and obviously I agreed. But can you believe this? When I boarded the plane to fly home, there she was, husband and children too. What an extraordinary coincidence. But I must say we were magnificent: didn’t even acknowledge one another. Two perfect strangers. She’ll be in Athens for a conference over Thanksgiving, and if there’s any way, I’ll be there too. The relationship’s impossible, of course. She says there’s no future. It was a moment, is all, and I respect her for that. I couldn’t respect anything else. But the fact is, it happened, Louis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He reached over and plucked the photo from the desktop. For a long moment he stared at it somberly. All the triumph had gone out of him. He seemed, suddenly, sad and old and tired. “Louis, Louis,” he said. “What was I thinking? Why do I do this to myself? I’ll never lay eyes on her again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He bit his lip, and for an appalling moment Louis thought his friend might start to cry. But he didn’t. Instead, he laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can I tell you?” he said. “We had so much sex I still ache all over. She was insatiable, Louis. She taxed my imagination severely. But I don’t think I disappointed her. This old man definitely has some surprises left in him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis wouldn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reid leaned forward in his chair and gripped the edge of the desk. “I feel like I’ve touched something real, Louis. Body and soul. Sometimes I actually get the feeling there really is some meaning to all this mess we call life. The smile of the divine. And there are other things—but I’ll tell you about them later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis did have to admit that—for whatever reason—Reid looked rather perversely radiant, as if that Athenian light, even now, enveloped him. Still, he couldn’t resist asking, “And how was Libby’s month on the Cape?” Perhaps it was his own failure, a small-minded lack of imagination in the face of some great adventure he failed entirely to comprehend. Nonetheless, he felt an acute itch of guilt about Libby, kept all these years in the dark. And for the sake of what?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reid, though, appeared unfazed. “Oh fine, fine,” he said. He picked up the photo and replaced it thoughtfully in his pocket. They’d not speak of her again, this American archaeologist from the dig at Pella. He’d had his say. Now she was between them; he’d safely housed her in Louis’s imagination—where she was free to undergo any number of awful metamorphoses.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s good for Libby to pack me off the way she does,” Reid said fondly. “Demanding old coot that I am. She loves her summers. She positively flourishes in my absence.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled broadly—almost as if he meant those words.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Shielded from the sun’s merciless glare by the sunglasses he felt so vulnerable without, Louis walked home feeling disconsolate and violated. How dare Reid barge in like that—not into his office, but into his soul? For the hundredth time, he decided theirs was a friendship he could no longer sustain. But how, after all these years, to end it? He was too vastly implicated, because Reid’s secrets really were entirely safe with him. There was that degree of brilliance in his friend’s careful organization of his affairs: here he lived beyond reproach; there, well, anything could happen. And with some regularity did. But were Louis, in some mad fit of candor, ever to reveal the sad truth about his friend, no one would believe him. This schoolteacher who delved into obscurest Byzantiniana, who wrote a pompous column called “The Religious Perspective” for the local newspaper, and whom, as a result, the students had dubbed Father Fallone—apparently without irony: he’d conned them all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nevertheless, a damning photo had lain briefly on Louis’s desk. What other tracks had Father Fallone foolishly left uncovered? Louis couldn’t escape the notion that, despite his care, Reid was still playing with fire, the kind that could without warning sheathe one’s whole life in irreversible conflagration.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis knew all too well about playing with fire. Years ago he should have said, simply, sternly, a scrupulously principled stance, “I don’t want to know.” But he’d been younger then and full of dangerous curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made a mental note to steer Tracy Parker clear of Reid’s orbit. There were too many ways of becoming entangled with someone like Reid, and the not-unfriendly word he’d been looking for, ever since their interview, to describe Tracy Parker finally came to him: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("guileless")]), _vm._v(". Perhaps, like Parsifal, a perfect fool.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now there was an amusing, frivolous thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sweat slid down his sides. He considered taking off his linen jacket and carrying it over his arm, but decided against it. He didn’t like the feeling of being unclothed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At Academy Avenue he paused for the crosswalk light to signal safe passage. Traffic streamed endlessly past, sleek new automobiles hermetically sealed against the tribulations of August. Even through dark lenses, the light off their windshields dazed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In some countries, India for instance, men weren’t afraid to be seen sauntering along under the shade of an umbrella. Would that he had the courage to put up an umbrella under this unremitting downpour of sunlight. But that had been the trouble with his whole life. A fear that people might notice; people might talk. That was why he found it impossible to imagine a single word of the book he’d fooled himself into thinking he’d spent years preparing for. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Closed Fist and Open Palm: Moral Discipline in the Works of Thomas Mann")]), _vm._v(". This past summer he had once again cleared a space for it; despite Claire’s urging, there had been no European vacation, not even a week on the Cape. Every morning he’d compelled himself, with faultless discipline, to inhabit his air-conditioned study for the three long hours between breakfast and lunch. And nothing had happened. Morning after morning he sat at his uncluttered desk and no thoughts came. He opened the diaries of Thomas Mann at random and read. He brooded over the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Observations of a Non-Political Man")]), _vm._v(" and the “Snow” chapter from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Magic Mountain")]), _vm._v(". Idly he wrote out certain names: Nepomuk Schneidewein, Pribislav Hippe, Clavdia Chauchat. This subject he knew everything and nothing about. It wasn’t so much that he had no thoughts in his head, but rather that, constipated from years of withholding, they now refused to issue forth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Certain pages had been written. He kept them in a black notebook, which, one day soon, he promised himself, he intended to destroy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He remembered Reid once chiding him: “You’re so straitlaced. Loosen up, my friend. Life is not a prison sentence.” Stupid not to have asked Reid for a lift home in that embarrassing, bright red sports car he drove these days. But the last thing he wanted this afternoon was Reid.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had always recognized that the path he had chosen would be difficult. He asked no pity, expected no compassion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sudden commotion behind made him turn his head. Two boys on bicycles had ridden up. In the roiling heat, they’d taken off their shirts and tied them to their handlebars. As was the fashion among teenagers these days, they wore their outsized jeans slung implausibly low on their hips; the ribbed waistlines of their boxer shorts showed a full two inches.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were thirteen or fourteen, with aggressive haircuts and earrings in their ears. One had a tattoo on his forearm: a rose or some other flower. Their bellies were smooth and hard, their chests thrown boldly forth against the wide world that was all theirs. He would not give them more than a single glance. There was something too obscene about them, too intimidating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Feral. He could almost smell it on them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But already he’d betrayed his nerves. He’d failed to notice that the light had finally changed. "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WALK")]), _vm._v(", the crosswalk sign commanded imperiously. “Out of the way, Pops,” one of the boys told him, while the other made what sounded like a farting noise with his lips as they charged past him with only inches to spare. He watched their naked backs, that interval of shorts between jeans and skin, the motion of their buttocks as they stood on their pedals and pumped furiously away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No doubt about it. He’d become a relic, something to be thrown away. There was no one else like him remaining in the entire world.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Claire had gone out, and Lux didn’t hear him come in; asleep on his pillow in the kitchen, the ancient dog raised his head as Louis entered the room, then heaved himself heavily to his feet. There he stood, unsteady, disoriented. Since his stroke last spring, he listed a bit to the left.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, old fellow,” Louis told him. He bent down to scratch behind the German shepherd’s ears. Clouded eyes watched him. “Feeling creaky today?” he asked as he unlatched the back door and held it open. “It’s the weather. That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lux made his way with difficulty down the two shallow steps. He waited a moment, confused, then took a few uncertain steps out onto the grass and squatted down. The outdoors seemed, these days, to overwhelm him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d have to be put down in the fall, before the cold came. They’d decided that. After thirteen years, it was going to prove difficult. Already Louis was severely dreading his own weakness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good fellow,” he praised as Lux made his painful way back up the steps and through the door. That long-ago autumn their second daughter had left for college, some loneliness had given Claire the idea of rescuing a dog from the pound. He’d have purchased a purebred himself, but he had given in, and perhaps she’d been right after all. No one could have asked for a sweeter companion these past twelve years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rummaging in the refrigerator, he found an end of kielbasa. Lux’s tail thumped the floor with something like his old liveliness. Louis had taken to indulging him, this good and faithful dog facing death at the hands of the humans he trusted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the counter, Claire had left a stack of mail—sans bills, which she’d weeded out. Through some set of circumstances he could no longer quite remember, those had become her domain quite early in their marriage. He sifted through what was left: a newsletter from their Republican congresswoman, a package from the Musical Heritage Society. The latest "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Yorker")]), _vm._v(" offered a vaguely displeasing cover, as seemed often to be the case these days, and its table of contents held little of interest. Except for their monthly ritual of the opera, they never ventured into the city anymore; it had become as strange and off-putting as the magazine that bore its name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the bottom of the stack of mail a flimsy blue airmail envelope lay. The gaudy stamp advertised itself as Tanzanian. Puzzled—who on earth might he know in Tanzania?—he carried the mysterious communication into his study and seated himself at his desk. He’d always opened letters with an inexplicable sense of dread.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Childish, blocklike letters lurched across the page.")]), _vm._v(" "), _c('div', {
    staticClass: "extractLetter"
  }, [_c('p', {
    staticClass: "extractLetterSalutation",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear Mr. Tremper")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Probably you won’t remember me. I graduated from the Forge six years ago. I was in your tenth grade literature class where we read")]), _vm._v(" A Separate Peace. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Now I’m in the Peace Corps here in the town of Arusha—hard to imagine! But I love it, I love what I’m doing. We’ve been building a bridge across a stream where usually the locals have to ford and in the rainy season it floods. It’s really")]), _vm._v(" satisfying "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to be helping people like this. I also tutor adults and children in English. They’re really a beautiful people here, the Liguru people")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So why am I writing. Well, the other day I was in this little library the Mormon missionaries run, and guess what I found there?")]), _vm._v(" A Separate Peace! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("So I took it out and read it all over again and I had so many memories. I remember our English class really well, it was a really important time for me. You were the teacher who first got me interested in English, which I ended up majoring in College (Ithaca College). It was the friendship between Finny and Gene I really related to, and the school stuff and all")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anyway I’d been thinking and I thought I’d just write and say thanks for the help and encouragement you gave me. It’s lonely here sometimes. The stars at night are really amazing, though. Maybe I’ll try to teach them to read")]), _vm._v(" A Separate Peace "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(my students, I mean!!)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "extractLetterSignature",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sincerely,"), _c('br'), _vm._v(" Robert Wainmark (Bobby)")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis vaguely remembered the thin-faced boy with big brown eyes who’d kept mostly to himself, sat toward the back of the class, rarely ever spoke. One of those adolescent enigmas one despaired of ever reaching. There’d always seemed something faintly sorrowful about him, some sadness that kept him quiet. His work had been earnest but mediocre. And had he written the occasional poem? Louis wasn’t entirely sure, six years down the road, but it seemed possible he’d turned in some vague, obdurate bit of lyric from time to time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On consideration, he seemed to remember that distinctly. And one of the younger teachers, a dorm adviser, had once mentioned that Bobby had problems with bed-wetting: that too came back to Louis. He read the letter over again, these words addressed to him from Africa, this young man—he’d be around twenty-three now—who’d thought of him on an African night under the lonely shining stars.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis was faintly embarrassed that he could recall so little about him. He swiveled his desk chair around to locate the atlas on the bookshelf. Opening the heavy tome on his lap, he perused pinked-tinted Tanzania’s cities—Dares Salaam, Dodoma, Iringa, Kigoma—until he found Arusha in the north, under the very shadows, it appeared, of Mount Kilimanjaro.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He himself had never been to Africa, would never go. The continent held too little interest for him, and far too much in the way of fear. Though northern Africa did beckon in its bleak, unforgiving way. As a boy he’d followed with secret admiration the campaign of Rommel’s Afrika Korps, their valiant and thrilling fight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He read the letter through a third time, then opened his filing cabinet, took out a manila folder, and filed it with a dozen or so similar letters he’d received over the years. What else did one do with an attempt at communication like that? If he were to write Bobby back, what would there be to say? He had answered some of his boys’ letters in the past, had even maintained a semblance of correspondence with one or two of them, but inevitably it petered out after a couple of years. They moved on to other things—as they should. Their prep-school teacher, having served his purpose with them, appropriately turned his attention to the latest crop of young minds needing encouragement, advice, lessons in various kinds of fortitude. From time to time, of course, he received stray news: This one had married into great wealth, or that one had earned a law degree, or was practicing medicine. More often, they moved docilely into their fathers’ businesses—a fate that had, he supposed, been the point for most of them all along. He didn’t mind, and if the Forge School alumni gave generously to the annual fund, he was hardly the one to complain. He prided himself on having few illusions. The world was a complex place, and there were many complex accommodations to be reached with it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Africa, the Peace Corps. Such a destination was a distinct rarity among his boys. He found himself oddly pleased with quiet, sad Bobby Wainmark.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Someone was speaking his name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Louis,” Claire said, quietly but firmly. She bent over him, gently prodding his shoulder as music played—the Bruckner string quintet he’d received in the mail from the Musical Heritage Society. He lay on the sofa, must have fallen asleep; yes, near the end of the adagio he’d grown so drowsy he’d closed his eyes, started to drift, and as happened whenever he first entered that slumbering state, the music had taken on the most deliciously heightened intensity. Melodies ached along his veins. A chord’s dissonances melted voluptuously somewhere near his heart. Music heard when half-asleep transformed itself into some nearly shameful language.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d forgotten they were scheduled for dinner at Reid and Libby’s. Rousing himself from the sofa, he told Claire, “It’s the weather, is all. That’s what’s getting to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had dressed for the occasion: black skirt, white blouse, a colorful scarf thrown about her neck. She loved dressing for occasions; the social moment still mattered to her. He himself had lost that. She accused him, only half humorously, of having grown curmudgeonly while she had soldiered on, still nursing some hope in the possibilities of human interaction. Perhaps it was their respective careers, the different kinds of human contact they allowed. He seldom found himself brooding over the strange fact that she, who never had shown aspirations toward any such thing in their younger years, had gone on in middle age, after their daughters left home, to finish a Ph.D. in English at the state university in Albany while his own benighted dissertation, abandoned so long ago at Cornell, would never see the light of day. Now she taught courses at the community college, and some nights tutored prisoners within the high, gloomy walls of the nearby correctional facility for women. With the years she had grown liberal, even radical. She helped the poor, the desperate, the disenfranchised—those were her very words—find their way into four-year colleges a rung or two below those his own students aimed for.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He supposed he could genuinely admire all that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As usual, Claire drove. It had been years since Louis had been behind the wheel, and he was no longer entirely certain he could be trusted there. But Claire had nerves of steel. She negotiated the Taconic and the Autobahn with equal ease, and he admired that about her too. The early evening air was still thick and heavy, but the light their Audi sped through had a kind of magnificence about it. Not like that Greek light Reid had floated in—but then he didn’t envy Reid one bit. This was his light, the tempered, shifting light countless painters on countless canvases (one hung, in fact, in his office) had tried to still. Except for his years at Cornell, he had lived in the Hudson Valley his whole life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re doing it again,” Claire told him. The sound of her voice made him jump.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She held up her fist, clenched and unclenched it several times.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry,” he told her. “I didn’t realize I was doing that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are you so anxious about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But if he was anxious, he had no idea of it. Yet her accusation sounded exactly right. “Oh,” he told her, “you know how I get every year before school starts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We should have gone away this summer,” she told him. “We should have taken those three weeks in Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think the summer’s been a complete waste,” he judged. But the truth of it bore in on him. Even the landscape, as they passed the new Wal-Mart that would spell the death of Middle Forge’s fragile Main Street, seemed suddenly blighted. He had sat at his desk. Nothing had happened. The summer, like his life, had passed him by.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A developer had bulldozed lots into what had been, at the beginning of the season, a grove of trees. Some miles beyond those suburban ravages, out in the still unspoiled countryside, Reid and Libby lived in the house they’d built when Reid came into his bit of inheritance. At the school, it had caused something of a controversy. Faculty were generally expected to live in faculty housing, either dormitory apartments or, for those married and with families, the row of houses along Academy Avenue. The Forge School was a residential campus. But Reid had been adamant, and Louis, then in his first year as headmaster, had let him have his way. Fifteen years later that moment of weakness still perturbed him. Dr. Emmerich would not have given in. Dr. Emmerich would have maintained faculty discipline. But Dr. Emmerich had died in a rainstorm on a country road at night, and Louis was on his own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Reid will be in his Hellenic mode,” Louis observed. “Ten to one we’re having shish kebab or some such thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire smiled indulgently at him, as she did whenever she caught him being mean. Weakness and meanness: certainly he had his share of failings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, he persisted. “Too pretentious, don’t you think? Inflicting one’s vacation on one’s guests.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s only trying to hold on to something before it slips away,” she said. “I think that’s perfectly understandable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He felt duly chastened, but perhaps he had wanted that. She always had large sympathies—and who benefited from them more than he?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Castel Fallone, he had privately dubbed Reid and Libby’s dream home. As with most dreams, it perhaps revealed unwanted truths. Behind the grandiose facade lay echoing, underused rooms. Reid and Libby had wanted but failed to produce children, and the house seemed sadly meant to accommodate that nonexistent family. And while Reid delighted in what he pompously called the cathedral spaces—he loved tootling endlessly on his reproduction harpsichord, its busy clatter resonating in the emptiness—Libby had always seemed ill at ease under those vaulted ceilings. She much preferred their dark, cramped cottage on the Cape, to which she fled during the summers when Reid went abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Meeting them at the door, awash in the rose perfume she had been in the habit of dousing herself with for as long as he’d known her, Libby looked flushed, hectic, as if she’d just managed to pull herself together the moment before their arrival. Louis felt fairly certain she had not turned into a furtive drunk on them; it was simply that time and circumstance had taken their toll on a woman who had once been rather beautiful. And summer seemed to have added a few pounds of its own to the weight of years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, you’re finally here,” she said, with a nervous buoyancy that, in turn, made him suddenly nervous. “Reid’s fired up the grill. I don’t know why he’s in such a hurry, but he claims he has an important announcement to make at dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Libby,” Claire complimented her, “you’re all tanned. Louis and I look like mushrooms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m well done is more like it,” Libby said. “Stick me with a fork and I’ll ooze butter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For some reason Claire found that funny. She rubbed her friend’s arm affectionately. They’d been roommates together at Barnard, and whenever they were around one another they instantly reverted to some impenetrable banter left over from their youth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He followed the two women through the blessed air-conditioning of the house, silently irked by the truth of what Libby had hinted at the door: They were, in fact, a good half hour late. And he hated people who were late. Clearly Claire had put off waking him as he lay slumbering on the sofa. It was a strange, inveterate incapacity of hers, far too ingrained to stand any changing at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the terrace in back, Reid looked comfortable in sandals, baggy jeans, a loose white shirt that failed to conceal his girth. He wore a straw hat. Without any success Louis tried to picture him as the conquering Lothario among the lady archaeologists. From a great bowl Reid lifted skewers dripping with marinade and laid them on the fire. Flames flared up, hissing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So he’d been right about the shish kebabs. He wondered if Claire would notice, but she seemed oblivious to this proof of his acuity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The perfect hot-weather drink,” Reid advertised, holding up a milky glass of ouzo and water. “The Greeks spent three thousand years perfecting it. I spent all summer drinking it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“An ouzo sounds delightful,” Claire said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A martini for me,” Louis demurred.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, the old staple. Some things never change with Louis, do they?” Reid teased Claire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Louis is very conservative,” Claire agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I really don’t care for ouzo,” Louis protested. “I never have. If you don’t mind, I’ll go fix myself a martini.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Suit yourself. You know where the makings are.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Busying himself with the grill, Reid wouldn’t look at his guest; as he made his way indoors Louis noted the avoidance with a quiet sense of wonder. Was Reid regretting the afternoon’s impulsive confession? Certainly such a thing had happened before; after an initial eagerness—even compulsion—to reveal all, he’d withdraw, and an awkwardness would fall between them for a few days. Mentally, Louis upbraided his friend: If you don’t want me to know something, then don’t tell me. But don’t punish me for hearing you out. Surely that was simple enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though Louis knew next to nothing, personally, about sexual regrets, the squeamish morning that followed some sordid night, the thought descended on him that Reid’s sudden awkwardness with him might be said to resemble, more closely than one might wish, exactly such a fit of regret.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The unbidden revelation put him in a very damp mood, and he found himself, in Castel Fallone’s cool and spacious kitchen, going a bit heavier on the gin than he otherwise might. He took a sip, then another. He knew he shouldn’t be drinking alcohol at all in this summer heat: liquor only made him sweat like the proverbial pig. But the promise of an announcement at dinner from Reid had him strangely on edge. He found himself thinking anxiously about that photo, the way Reid’s lady friend looked at the camera, her glare at once fierce and hungering. Were archaeologists really such a sex-starved lot as all that? Did pigs really sweat?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Imagining, suddenly, a vast slurping muck of a mudhole, in a mighty swallow he drank the whole of his martini; then, feeling slightly ashamed, he made himself another. Out the window, he could see the three of them on the terrace, Reid holding forth before his appreciative audience. If any of them wondered where he’d taken himself off to, they showed no sign of it. Surely he wasn’t jealous. Or if he was, then of what was he jealous?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another phrase rattled around his head: to seize life by the throat. There had always been something vaguely goatish about Reid Fallone; didn’t he, in a sense, devour everything that came his way?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Judging himself sufficiently fortified, he sauntered, fresh martini in hand, back outside. The warm air enveloped him. Reid was waxing apocalyptic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d sit in the cafés of these prosperous Macedonian cities and feel it all around me in the air: how these people are worried sick about their future. You see on banners everywhere, ‘Pray for the Peace of the Balkans.’ And well they should pray. This time next year, it’s them we could be reading about in the papers, and they know it. Things could happen just like that. Snipers, guns in the hills. Would the rest of the world give a damn? It’s why the Greeks are backing Serbia, and I have to say I agree with them. ‘Greece: Serbia loves you.’ I saw that graffiti everywhere. There’re just too many people out there who want to get their hands on Greek Macedonia. The Albanians, the Bulgarians. The Turks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The last word rang in the air ominously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis had tried to follow it all in the newspapers, but the situation left him confused and depressed. Everything was too entangled, too deeply rooted. What had seized him most was the destruction of the beautiful Ottoman bridge at Mostar. Now "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" had had an awful clarity about it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Serbs have shown themselves to be out-and-out butchers,” he said with sudden certainty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s plenty of butchery on all sides,” Reid returned just as certainly. “What the Serbs have done is nothing compared to centuries of Turkish tyranny. Islam. That’s the real thorn. A Muslim state in the heart of Europe. It’s in no one’s best interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Except, I guess, those Muslims who already have the misfortune to be living in what you call the heart of Europe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The entanglements are tragic,” Reid conceded. “And then there’s the whole German angle: Germany recognizing Croatia. All those old alliances and memories. The Ustashe and all that. And now the Germans want to send peacekeeping troops—which of course Serbia will never stand for, given what the Nazis did there. Nor will the Russians.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis wasn’t sure he wanted to know exactly what the Nazis had done. Reid had baited him and he’d allowed himself to be drawn in, only to discover he was at a distinct disadvantage. Reid was the one who had been there, after all. Reid had seen things with his own eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He often felt his erstwhile friend had that particular advantage over him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a gesture of resignation, he withdrew, even as Reid announced that the kebabs were done. “I thought,” he said, “we’d eat outside. The evening’s so lovely.” Louis’s heart sank. No one, it seemed, minded this heat the way he did. To the west, he saw with some relief, Valhalla-like thunderheads were rising. A storm’s sudden violence might just cool things off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From a sweating tin pitcher, another Greek affectation, Reid poured cold glasses of retsina all round. Raising his glass in a toast, he announced, “To good friends, who are the most important thing to me in the world. And so I want to share with my good friends an important development in my life.” He looked at each of them in turn, finally resting his gaze on Louis. And Louis realized that, earlier, he’d been entirely wrong: Reid wasn’t ashamed at all. He was decisive and defiant; he challenged them all to find fault with his reckless way of moving through the world. “I made a very serious decision about my life this summer,” he continued in a grave, measured voice. “What I’ve done, I haven’t done lightly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis felt his stomach go sour with anxiety. Rather than meet Reid’s unwavering gaze—it was as if Reid meant this announcement for him alone—he stared resolutely into his wine. A film of condensation had settled over the surface of the glass. He waited tensely. He braced himself. He thought he could hear thunder in the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What I’ve done,” Reid said, “is make a conversion to the Greek Orthodox faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis couldn’t have heard that correctly. “You’ve what?” he said, the words out of his mouth before he could rein them in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Face it,” Reid told him with a shrug that was suddenly impish, as if the whole thing were some elaborate practical joke. “I’ve been inching toward this for years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Libby laughed loudly. “And I was worried you’d been diagnosed with cancer,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis glanced at her with surprise. That had certainly never occurred to him, but perhaps it should have. Things would happen to them, after all. Libby herself had already been touched once by mortality’s dark finger. The smudge remained to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sudden memory overtook him—from years before, his one visit to Greece. A monastery, unprepossessing outside, claustrophobic inside, floor-to-ceiling martyrdoms of every imaginable variety, all rendered with grisly relish. Suddenly into that dark interior had flooded a group of schoolchildren. Candles were lit. Under the eager eyes of nuns, they lined up to kiss the icon of the Blessed Virgin, two dozen avid young lips giving adoration in a gesture both greedy and cloying. It was to this that Reid had given himself over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Libby,” Louis asked desperately, avoiding Reid’s eyes, his smug contentment, “really—what do you think about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think he’s quite serious,” she said. She stared ahead with that fiercely distracted look that overtook her features with increasing frequency of late. It seemed unnecessarily cruel for Reid to have exposed her like this, without warning. But she took it admirably in stride. “Not my thing, certainly. But then he’s not asking me to do anything. He isn’t even asking me to understand, particularly. Are you, Reid?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” he said, gently, almost regretfully, but at the same time with a chilling implacability, “as a matter of fact I am not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Libby looked at her husband, and then at Louis. She smiled, but her smile was entirely unreadable. Perhaps she was only stunned—as he was—or perhaps truly indifferent. Louis had never in his life understood her. There were times, in fact, when he’d positively feared her incomprehensibility. She was his wife’s best friend. Their enduring admiration for one another much predated his own arrival on the scene.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Orthodox Church offers a great many things to admire,” Reid said, though Louis had difficulty focusing on his sentences. “Not the least is the liturgy’s incessant striving for the sublime. Nothing so mundane as human reason encumbers those divine words. It’s not about speaking, it’s about singing. About mystery and miracle and ecstasy. The intervention of the divine in earthly affairs. A kind of cosmic lightning strike on the terrestrial.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ick,” Louis felt he had to say. He could only think of the American woman who led the excavation at Pella. What part, he wondered, did she play in all this ridiculousness? Still, the illusion of love had, in its time, led to stranger depravities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reid seemed to sense that. “Not all that different from your Wagner, really. What else is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Parsifal")]), _vm._v(", after all?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An immediate retort failed him. Thomas Mann had called the opera “a compound of religious impulse, sheer lasciviousness, and sure-handed competence that comes across as wisdom.” He’d perused those words that very morning, in his study, in one more futile attempt at work. But surely that assessment was wrong too; surely it missed the point.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unless it was precisely the point. Perhaps everything, when one came down to it, involved some degree of sham at its heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does this mean you’re obligated to go around kissing icons now?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Reid only laughed his most capacious belly laugh. “Louis,” he said. “You sound like I’ve betrayed you. It’s not that I’ve become a Hindu or a homosexual or anything so dire as that. As I see it, I’m returning to the common roots of our faith. Of all the versions of Christianity available to us, this is perhaps nearest to the original. Don’t I remember you once saying, if you were a Catholic, you’d have fought Vatican Two tooth and nail? The mass is meant to be said in Latin, I think you argued—and quite persuasively, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" said that. Leave it to Reid to quote him out of context. “I also said, if you’ll remember, that you can’t be other than what you are. What you were raised to be, that is. In your case—and mine too—once an Episcopalian, always an Episcopalian. To try to be anything else is disingenuous at best.” He heard his voice trembling with an anger the situation itself didn’t perhaps entirely warrant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Claire, he could sense, was watching him with great curiosity, even fascination.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So education is hopeless,” Reid extrapolated, his voice cool and measured. Clearly he was enjoying this. “You’re saying you can’t grow out of anything. You can’t transcend your own particular cultural or historical prison.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re twisting my meaning,” Louis said sharply, hitting the flat of his hand against the table. “You always do that.” The impact knocked over his wineglass, which he tried to catch but only succeeded in propelling off the table and, with an explosive shatter, onto the flagstones of the patio. The commotion didn’t prevent him from hearing Libby tell Claire, quietly but in all seriousness, “They’re very happy to see one another. It was a long summer they spent apart.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The longed-for storm from the west had never materialized. Thick, hazy moonlight silvered the hills. The road was a mirror spread out before them. Under his wife’s sure hand the Audi streamed through the sleeping countryside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a child he’d loved being taken for car rides at night, being out in the darkness but shielded from its harms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I must say, Reid is looking awfully well these days,” Claire observed. “Both of them, in fact. Their summers apart always seem to invigorate them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They hadn’t spoken since leaving. The mildness of her tone reassured him. He had thought she was angry with him, but apparently she wasn’t, even though his behavior had undoubtedly given cause. Her ability to forgive was one of the things he thought her remarkable for.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I must say I admire that marriage,” she went on. “They’ve rather sensibly managed to accommodate one another over the years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Louis was silent. He still felt a little drunk, though it was wearing off, and an unpleasant metallic taste had settled in his mouth. How much did Claire "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" know about those accommodations she so admired?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it was a subject he wouldn’t broach, at least not head-on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Frankly, I worry,” he said. “They’re both getting fat. That’s always a sign of something amiss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could sense Claire smile at him from behind the wheel of the Audi.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Moral failing in your book,” she said. “Comfortable is what I’d call them. Occupying a fuller space in the world. They haven’t been content, either one of them, to stay put. They’ve both grown over the years. It hasn’t always been easy. I think there’s a lot to be said for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fat,” he repeated, letting the ugly word hang in the darkness. He was doing it again. He wondered if Claire would have put on more than the modest number of pounds that she had, over the years, had he not been there to steady her course.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve really been in some mood all evening,” she pointed out. “You were practically impossible back there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Reid is such a hypocrite,” he told her. “Conversion my ear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Changes upset you,” Claire diagnosed. “I’ve never seen anybody who was so heavily invested in the status quo.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not the change,” Louis defended himself. “I don’t care what religion he professes. It’s just the sheer perversity of it. I’d like to think I take religion a little more seriously than that. And did you see how Libby just sat there? She didn’t know what to do. I feel so sorry for Libby sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I think Libby knows what’s what. She’s stayed married to him, after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Talk about a miracle,” Louis said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He felt once more on the verge of something. It would be so easy simply to say what he knew. A few frank words formed themselves in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He couldn’t do it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the dark he wished he could see his wife’s face, decipher what she might be thinking. Because perhaps it wasn’t necessary to say these things. Perhaps she already knew. How could she not know? And Libby also. People always knew more than you gave them credit for. Perhaps, in the end, no one had any secrets at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In which case, perhaps better for everything to remain in silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The miracle,” Claire said, “is that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anybody")]), _vm._v(" stays together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment he let her words lie. But then he felt he should say, “I think we’ve done pretty well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh,” Claire confirmed, “all things considered, I think the two of us have done remarkably well.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Bobby Wainmark was teaching the Africans to read. “Like this,” he said in his flat baritone. Into his mouth he put several tiny silver bicycles. Then, taking Louis by the hand, he led him across an empty stretch of desert dotted with what appeared to be small Byzantine chapels. Great unfamiliar birds, much larger than crows and brilliantly plumed, strutted about on the ground preening themselves. Under the open, star-filled sky, several ebony-skinned African boys lay sleeping on pallets, eyes closed, arms crossed over their thin chests. Bobby moved to the first and leaned over, placing his lips against the boy’s lips. Louis could see him transfer into the boy’s mouth a silver bicycle. Then he moved to the next and repeated the gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sight filled Louis with revulsion. “Now,” Bobby said in a curiously detached voice when he had finished, “all that remains is to fertilize the egg.” He seemed to be wearing some kind of ritual garb involving a skirt, and he made as if to undo it at the waist, was just on the verge of pulling the cloth back, when Louis woke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned on the lamp and slid from under the covers to sit on the side of the bed. Three o’clock. He’d dreamed badly, he knew, but already it had faded. Claire slept peacefully beside him. How could one get to the age of sixty and still sleep so peacefully? Their conversation in the car had not left him happy. Once an Episcopalian, always an Episcopalian, he had once said, leaving out the inconvenient fact, known to no one now but himself, that he’d grown up Baptist and converted to that statelier religion during the tumultuous years of college. It had offered him—at least this was what he had believed at the time—some ideal image of himself. In his heart of hearts he suspected he did not believe in God at all, but only in religion. Its social force, its powers of policing and restraint.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His life seemed to him, sometimes, a geography riven with fractures and fault lines that could only, over time, yield to disaster. And yet the disaster, for some reason, had never seen fit to occur.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was it a sin to suspect a truth and never to utter that suspicion to a soul?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the middle of the night, the bedroom seemed small, somehow shabby. There were cracks in the plaster near the ceiling. The dresser was cluttered with photos of Susan and Caroline at various ages. He felt wide awake. A phrase was in his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Left in the lurch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What in fact was a lurch, that one could be left in it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He felt mildly irked at Tracy Parker for having planted such a thought in his head. Had he known how it would come back to haunt his interviewer in the middle of the night?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He got up stiffly, slipped his feet into slippers, and went over to the closet. Pulling from its hanger his deep blue robe, he wrapped himself thoughtfully in its luxurious fabric. Then he made his way downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the desk in his study, the atlas still lay open to the map of Tanzania. So Reid had had a summer mistress, and he had gotten a letter from Africa. In its way that letter had cheered him. It had been the best moment in a day of only ordinary difficulty. But then, for the first time since waking, he remembered his dream with some clarity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frowning, he closed the atlas, returned it to its shelf, and withdrew the dictionary that sat next to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lurch,” he read, his finger following the fine print. “From the Middle High German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lurz")]), _vm._v(", meaning the left hand, by way of the Old English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("belyrtan")]), _vm._v(", to deceive. A situation at the close of various games in which the loser scores nothing or is far behind his opponent. Embarrassment, disadvantage, discomfiture. Obsolete, except in the phrase ‘to leave in the lurch’: to desert someone in time of trouble; leave in a desperate situation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, he thought as he shut the book, that was a fine and useful phrase if ever there was one. He’d have to remember to enlighten the newest member of the Forge School’s teaching faculty when next he saw him.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749c63e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466806207_ch01.vue
// module id = 69
// module chunks = 0